import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const GeenToegang = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md text-center space-y-4" data-testid="geen-toegang-page">
        <ShieldOff className="w-12 h-12 text-amber-500 mx-auto" />
        <h1 className="text-xl font-bold text-[#1f2548]">Geen toegang tot Truckwash-ops</h1>
        <p className="text-sm text-slate-600">
          Je account ({user?.email || 'onbekend'}) heeft op dit moment geen toegang
          tot deze tool. Neem contact op met de TW1 super-owner om toegang aan te vragen.
        </p>
        <p className="text-xs text-slate-400">
          Toegang en rollen worden centraal beheerd in TW1 Identity Platform.
        </p>
        <button
          onClick={logout}
          className="px-4 py-2 bg-[#1f2548] text-white rounded text-sm"
          data-testid="geen-toegang-uitloggen"
        >
          Uitloggen
        </button>
      </div>
    </div>
  );
};

export default GeenToegang;
